import {utils} from 'ethers';

export class HashGenerator {
    static createResaleFixPriceHash(tokenContractAddress: string,
                                    tokenId: number,
                                    tradeId: string,
                                    priceInEth: number): string | null {
        const priceInWei = utils.parseEther(priceInEth.toString());
        return utils.solidityKeccak256(
            ['address', 'uint', 'string', 'uint'],
            [tokenContractAddress, tokenId, tradeId, priceInWei]);
    }
}